import MeepoState from './meepo-state';
import {IResumenDiario, IUser} from '../utils/models';
import {isEqual} from 'lodash';

export default class MeepoStateEditor {

    public state: MeepoState;
    private rawState: any;
    private isMutated: boolean = false;

    public constructor(state: MeepoState) {
        this.state = state;
        this.rawState = state.getRawState();
    }

    public setIsAuthenticated(isAuthenticated: boolean) {
        if (this.state.getIsAuthenticated() !== isAuthenticated) {
            this.rawState.isAuthenticated = isAuthenticated;
            this.isMutated = true;
        }
    }

    public setIsLoading(isLoading: boolean) {
        if (this.state.getIsLoading() !== isLoading) {
            this.rawState.isLoading = isLoading;
            this.isMutated = true;
        }
    }

    public setIsProcessLoading(isProcessLoading: boolean) {
        if (this.state.getIsProcessLoading() !== isProcessLoading) {
            this.rawState.isProcessLoading = isProcessLoading;
            this.isMutated = true;
        }
    }

    public setUsuarioPerfil(usuarioPerfil: IUser) {
        if (!isEqual(this.state.getUsuarioPerfil(), usuarioPerfil)) {
            this.rawState.usuarioPerfil = usuarioPerfil;
            this.isMutated = true;
        }
    }

    public setResumenDiarioXRuta(resumen: IResumenDiario[]) {
        if (!isEqual(this.state.getResumenDiarioXRuta(), resumen)) {
            this.rawState.resumenDiarioXRuta = resumen;
            this.isMutated = true;
        }
    }

    public commit(): MeepoState {
        return this.isMutated ? new MeepoState(this.rawState) : this.state;
    }
}



// WEBPACK FOOTER //
// ./src/reduxstore/meepo-state-editor.ts